export const INDENT_TEXT_ATTRIBUTE = "indent-text";
export const INDENT_TEXT_COMMAND = "indent-text";
export const INDENT_TEXT_DEFAULT_MEASURE = "em";
export const INDENT_TEXT_DEFAULT_VALUE = 2;
